<gc-doctor-card #doctorCard [doctor]="doctor"></gc-doctor-card>
<div>
  <mat-divider class="divider"></mat-divider>
  <span class="center">
    <span class="overline">
      {{
        this.shortestBookingType?.earliestTimeslotDay &&
          ('availability_for_day' | translate: { day: (this.shortestBookingType.earliestTimeslotDay.date | todayTomorrow) })
      }}
    </span>
    <mat-icon
      *ngIf="showTimezoneWarning"
      class="icon"
      matTooltip="{{ 'timezones_differ_from_practioners' | translate }}"
      matTooltipPosition="above"
      matTooltipClass="tooltip-warning"
      svgIcon="alert-circle-outline"
      (click)="tooltip.toggle()"
      #tooltip="matTooltip"
    ></mat-icon>
  </span>
  <div *ngIf="this.doctor.bookingTypes !== null; else noConnection">
    <!-- Null means it has errored -->
    <div class="button-container">
      <div *ngIf="shortestBookingType; else loader">
        <div class="timeslots" *ngIf="timeslots.length; noTimeslots">
          <div *ngFor="let timeslot of timeslots">
            <button
              class="timeslot-button"
              mat-raised-button
              color="primary"
              (click)="doctorCard.makeBooking(doctor.uuid, shortestBookingType.uuid, timeslot)"
            >
              {{ timeslot }}
            </button>
          </div>
        </div>
      </div>
      <ng-template #loader>
        <mat-progress-bar *ngIf="loadingTimeslots; else noTimeslots" class="progress-bar" mode="indeterminate"></mat-progress-bar>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="booking-button"
          *ngIf="doctor.uuid"
          (click)="doctorCard.makeBooking(doctor.uuid)"
        >
          {{ bookingButtonTitle }}
        </button>
      </ng-template>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="booking-button"
        *ngIf="doctor.uuid && timeslots.length"
        (click)="doctorCard.makeBooking(doctor.uuid)"
      >
        {{ bookingButtonTitle }}
      </button>
    </div>
  </div>
  <ng-template #noConnection>
    <div class="no-connection">
      <div class="no-timeslots warning text">
        <mat-icon svgIcon="alert"></mat-icon>
        <span>{{ 'oh_no_cant_connect_to_their_diary_retry' | translate }}</span>
      </div>
      <button mat-raised-button color="accent" (click)="getTimeslots()">{{ 'retry' | translate }}</button>
    </div>
  </ng-template>
</div>

<ng-template #noTimeslots>
  <div class="no-timeslots">
    <mat-icon svgIcon="clock"></mat-icon>
    <span>{{ !!this.doctor.uuid ? ('no_availability' | translate) : ('doctor_not_setup_for_online_bookings' | translate) }}</span>
  </div>
</ng-template>
